<template>
  <div class="header-wrapper">
    <a href="https://threathunter.cn">
      <img src="../../../assets/img/header/logo.png" class="logo" alt="" />
    </a>
    <el-dropdown>
      <span class="opt-text">
        {{ userInfo.email }}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="logout">退出账号</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import http from "@/services/http";
import { api } from "@/services/api";
export default {
  computed: {
    userInfo() {
      return this.$store.state.user;
    }
  },
  methods: {
    /**
     * 退出账号
     */
    async logout() {
      const res = await http.get(api.user.LOGOUT());
      if (res === 200) {
        this.$store.commit("login", false);
        this.$store.commit("getPermissions", []);
        this.$store.commit("getEmail", "");
        this.$store.commit("getProductLoading", false);
        this.$router.push({ path: "/login" });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header-wrapper {
  height: 70px;
  background: rgba(31, 35, 46, 1);
  position: relative;
  .logo {
    position: absolute;
    left: 35px;
    top: 15px;
    width: 133px;
    height: 40px;
    cursor: pointer;
  }
  .el-dropdown {
    position: absolute;
    right: 58px;
    top: 50%;
    transform: translate(0, -50%);
    .opt-text {
      color: #ffffff;
    }
  }
}
</style>
